import React, { useState } from "react";
import { useAppSelector, useAppTranslation } from "@/utils";
import { Button, Col, Drawer, Input, LegacyForm, Row, Space, Typography } from "@payping/web-components";
import { Close } from "@payping/icons";
import EditActionButtons from "@/components/mobile/settings/EditActionButtons";
import { DashboardRoutes } from "@/router/constant";
import { useHandleNavigationURL, useSaveToRedux } from "../utils";
import { settingsBusinessAtom } from "../../state";
import { selectAtom } from "jotai/utils";
import { useAtom } from "jotai";

const mobileFormEditAtom = selectAtom(settingsBusinessAtom, (val) => val.mobileFormEdit);

const MobileEditBusinessTaxcode: React.FC = () => {
  const [isDrawerOpen, setIsDrawerOpen] = useState(true);

  const { t } = useAppTranslation();
  const [form] = LegacyForm.useForm();
  const [mobileFormEditState] = useAtom(mobileFormEditAtom);

  // < دکمه استعلام کد مالیاتی به درخواست پروداکت فعلا برداشته شد >
  // const [modals, contextModal] = Modal.useModal();
  // const isLocalDisabled = useAppSelector(
  //   (state) => state.user.checks?.localStatus === DashboardChecksTypeEnum.Confirmed
  // );
  // const businessInfo = useAppSelector((state) => state.user.businessInfo);
  const taxCodeApi = useAppSelector((state) => state.user.businessInfo?.taxCode);

  /* < دکمه استعلام کد مالیاتی به درخواست پروداکت فعلا برداشته شد >
  const [{ loading: getTaxInquiryLoading }, getTaxInquiryHandler] = useAsyncFn(
    async () => {
      try {
        // `isSilent: true` because error display in modal
        const response = await userApis.taxInquiryGet({ isSilent: true });
        if (response?.taxCode) {
          form.setFields([{ name: "taxCode", value: response.taxCode }]);
          form.validateFields(["taxCode"]);
          if (!response.isActive) {
            modals.error({
              content: (
                <Trans
                  i18nKey={t("User:profile.business.inActiveTax")}
                  values={{ code: response.taxCode }}
                  components={[<Typography.Link key={0} href={`https://mytax.tax.gov.ir`} />, <code key={1} />]}
                />
              ),
              title: t("error.title"),
            });
          }
        }
      } catch (e: any) {
        if (e?.message) {
          modals.error({
            content: e.message,
            title: t("error.title"),
          });
        }
      }
    },
    [],
    undefined,
  );
  */

  // Custom Hooks
  const { saveToRedux } = useSaveToRedux();
  const { handleNavigationURL } = useHandleNavigationURL();

  return (
    <>
      <Drawer
        open={isDrawerOpen}
        placement={"bottom"}
        size={"100%"}
        title={`${t("edit")} / ${t("taxCode")}`}
        closeIcon={false}
        extra={<Button type={"text"} icon={<Close width={14} height={14} />} onClick={handleNavigationURL} />}
      >
        <Space orientation={"vertical"}>
          <LegacyForm
            onFinish={({ taxCode }) =>
              saveToRedux({
                nextUrlForMobileRegisterURL: DashboardRoutes.register.mEditBusiness.businessRegistrationStatus.url,
                fieldName: "taxCode",
                fieldValue: taxCode,
                setIsDrawerOpen,
              })
            }
            form={form}
            initialValues={{ taxCode: mobileFormEditState.taxCode ?? taxCodeApi }}
          >
            <LegacyForm.Item label={t("taxCode")} dependencies={["taxCode"]}>
              {() => (
                // < دکمه استعلام کد مالیاتی به درخواست پروداکت فعلا برداشته شد >
                // const taxCode = getFieldValue("taxCode");
                // const showInquiry = taxCode && businessInfo?.taxCode !== taxCode && taxCode.length >= 10;

                <Row gutter={[8, 8]}>
                  <Col xs={24}>
                    <LegacyForm.Item
                      noStyle
                      name="taxCode"
                      rules={[
                        () => ({
                          validator(_, value) {
                            if (!value || value.length === 10) {
                              return Promise.resolve();
                            }
                            return Promise.reject(new Error(t("settings.business.errors.taxCode")));
                          },
                        }),
                        { required: true },
                      ]}
                    >
                      <Input maxLength={10} />
                    </LegacyForm.Item>
                  </Col>
                  {/* < دکمه استعلام کد مالیاتی به درخواست پروداکت فعلا برداشته شد > */}
                  {/*
                    <Col xs={showInquiry ? 12 : 0}>
                      {showInquiry ? (
                        <Button disabled={getTaxInquiryLoading} onClick={() => getTaxInquiryHandler()} block>
                          {t("profile.business.taxInquiry")}
                        </Button>
                      ) : null}
                    </Col>
                    */}
                </Row>
              )}
            </LegacyForm.Item>
          </LegacyForm>
          <Typography.Text type={"secondary"}>- {t("settings.business.instructions.taxationCode1")}</Typography.Text>
          <Typography.Text type={"secondary"}>- {t("settings.business.instructions.taxationCode2")}</Typography.Text>
        </Space>
      </Drawer>
      <EditActionButtons onAccept={form.submit} />

      {/* < دکمه استعلام کد مالیاتی به درخواست پروداکت فعلا برداشته شد > */}
      {/*
      {contextModal}
      */}
    </>
  );
};

export default MobileEditBusinessTaxcode;
